import Drift from 'drift-zoom';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import React, { useCallback, useEffect, useRef, useState, useMemo } from 'react';
import Swiper, { Navigation, Thumbs, A11y, Lazy } from 'swiper';

import { Cookie } from '@/tscapi/utils/cookie';

import { IProduct } from './IProduct';
import EventBus from './PdpEventBus';
import PdpVideoItem from './PdpVideoItem';
//import MobileGallery from './PdpMobileGallery';
//import PhotoSwipe from 'photoswipe';
import 'photoswipe/style.css';
export interface PdpProps {
    productData: IProduct;
}
const PdpGallery = ({ productData }: PdpProps) => {
    const [gotoSlide, setGotoSlide] = useState(null);
    const [slideIndex, setSlideIndex] = useState(0);
    const [videoData, setVideoData] = useState({
        slideNumber: null,
        slideElement: null,
        videoFile: null,
        id: null,
        videoContainerID: null,
    });
    const [swiperInstance, setSwiperInstance] = useState(null as Swiper);
    const swiperRef = useRef(null as Swiper);
    const swiperRefThumb = useRef(null as Swiper);
    const lightRoomRef = useRef(null);

    const [isAutoPlayEnabled, setIsAutoPlayEnabled] = useState(() => {
        const cookie = new Cookie();
        const autoPlayCookie = cookie.AutoPlayVideos;
        if (autoPlayCookie == undefined) {
            cookie.AutoPlayVideos = '1';
            return true;
        }
        return autoPlayCookie === '1';
    });
    const slidesListChildren = document.getElementById('swiper-wrapper').children;
    const slidesList = Array.from(slidesListChildren).map((x) => x.id);

    const [isZoomed, _setIsZoomed] = useState(false);
    const zoomRef = React.useRef(isZoomed);
    const setIsZoomed = (data) => {
        zoomRef.current = data;
        _setIsZoomed(data);
    };
    const edps = useMemo(() => {
        return !productData.Edps ? [] : productData.Edps;
    }, [productData.Edps]);

    const getDefaultEdpItem = useCallback(() => {
        return edps.find((edpItem) => edpItem.EdpNo === productData.DefaultEdp);
    }, [edps, productData.DefaultEdp]);
    const getDefaultIndexValue = () => {
        //const position = edps.findIndex((edpItem) => edpItem.EdpNo === productData.DefaultEdp);
        const defaultElement = document.querySelector('.defaultSlide') as HTMLElement;
        //console.log('initial:' + Number(defaultElement.dataset.index));
        //return Number(defaultElement.dataset.index);
        return 0;
    };

    const getIsAutoPlayEnabledFromCookie = () => {
        const cookie = new Cookie();
        const autoPlayCookie = cookie.AutoPlayVideos;
        if (autoPlayCookie == undefined) {
            cookie.AutoPlayVideos = '1';
            return true;
        }
        return autoPlayCookie === '1';
    };
    const findFirstVideoIndex = () => {
        if (productData.Videos.length > 0) {
            return 0;
        } else {
            return -1;
        }
    };
    const onAutoPlayChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const isChecked = e.target.checked;
        setIsAutoPlayEnabled(isChecked);
        const cookie = new Cookie();
        cookie.AutoPlayVideos = isChecked ? '1' : '0';
    };
    const slideToCarouselByID = (dimensionValue) => {
        setGotoSlide(slidesList.indexOf('img-' + dimensionValue));
    };
    const isCurrentSlideVideo = () => {
        if (getCurrentSlideID().includes('vid-')) {
            return true;
        }
    };
    const isSlideImage = (index) => {
        const slideByIndex = swiperRef.current.slides[index].id;
        if (slideByIndex.includes('img-')) {
            return true;
        }
    };
    const getCurrentSlideID = () => {
        if (swiperRef.current) {
            return swiperRef.current.slides[swiperRef.current.activeIndex].id;
        }
    };
    const getCurrentData = () => {
        if (isCurrentSlideVideo()) {
            const slideElement = swiperRef.current.slides[swiperRef.current.activeIndex];
            return {
                slideNumber: swiperRef.current.activeIndex,
                slideElement: slideElement,
                videoFile: slideElement.getAttribute('data-video'),
                id: slideElement.id,
                videoContainerID: `video-container${slideElement.id.replace('vid-', '')}`,
            };
        } else {
            return {
                slideNumber: swiperRef.current.activeIndex,
                slideElement: null,
                videoFile: null,
                id: null,
                videoContainerID: null,
            };
        }
    };
    function scrollToSizeChart(e, element) {
        e.preventDefault();
        const target = element.getAttribute('data-href');
        const $trget = $(target);
        // Example: your header is 70px tall.
        const newTop = $trget.offset().top;
        $('html, body').animate(
            {
                scrollTop: newTop,
            },
            500,
            'swing',
            function () {
                window.location.hash = target;
            },
        );
    }

    useEffect(() => {
        const instance = initGallery();
        const handleGallerySlide = (data) => {
            slideToCarouselByID(data.dimensionId);
        };
        //setup event bus handler to look for msgs from PDP Description Area
        EventBus.on('gotoSlide', handleGallerySlide);
        return () => {
            EventBus.remove('gotoSlide', handleGallerySlide);
        };
    }, []);

    useEffect(() => {
        if (swiperRef.current && gotoSlide != null) {
            swiperRef.current.slideTo(gotoSlide, 0);
            swiperRefThumb.current.slideTo(gotoSlide, 200, false);
        }
    }, [gotoSlide]);

    const isMobileDevice = () => {
        return window.innerWidth < 992;
    };

    const mountZoom = (swiperGallery) => {
        const paneContainer = document.querySelector('#pdp__gallery');
        const assets = swiperGallery.el.querySelectorAll('.gallery__image--aspect-ratio');
        const images = Array.from(assets as NodeList);
        const driftSettings = {
            paneContainer: true,
            containInline: true,
            inlinePane: true,
            boundingBoxContainer: paneContainer,
            inlineContainer: paneContainer,
            zoomFactor: 3,
            onHide() {
                document.getElementById('pdp__gallery').classList.remove('zoom');
            },
        };
        images.forEach((imageContainer) => {
            if (!isMobileDevice()) {
                new Drift(imageContainer, driftSettings);
                const galleryLinks = document.querySelectorAll('a.gallery__image--aspect-ratio-wrap');
                galleryLinks.forEach(function (link) {
                    link.addEventListener(
                        'click',
                        (e) => {
                            //e.stopPropagation();
                            e.preventDefault();
                            return false;
                        },
                        true,
                    );
                });
            }
            imageContainer.addEventListener('mouseleave', () => {
                zoomRef.current = false;
                document.getElementById('pdp__gallery').classList.remove('zoom');
            });
        });

        //if mobile
        if (isMobileDevice()) {
            //const lightbox = MobileGallery();
            const photo_swipe_options = {
                gallery: '#pdp__gallery .drift-zoom-container',
                pswpModule: () => import(/* webpackChunkName: "photoswipe" */ 'photoswipe'),
                loop: false,
                zoom: true,
                arrowKeys: true,
                bgOpacity: 0.3,
                wheelToZoom: true,
                initialZoomLevel: 2,
                secondaryZoomLevel: 2,
                maxZoomLevel: 2,
                getViewportSizeFn: function (options, pswp) {
                    return {
                        x:
                            document.documentElement.clientWidth >= 768 && document.documentElement.clientWidth <= 992
                                ? document.documentElement.clientWidth - document.documentElement.clientWidth * 0.1
                                : document.documentElement.clientWidth,
                        y:
                            document.documentElement.clientWidth >= 768 && document.documentElement.clientWidth <= 992
                                ? document.documentElement.clientHeight - document.documentElement.clientHeight * 0.1
                                : document.documentElement.clientHeight,
                    };
                },
                tapAction: 'zoom-or-close',
            };
            //@ts-ignore
            lightRoomRef.current = new PhotoSwipeLightbox(photo_swipe_options);
            lightRoomRef.current.on('close', () => {
                swiperGallery.allowTouchMove = true;
            });
            let firstElWithBadge;
            let lastElWithBadge;

            // Gallery is starting to open
            lightRoomRef.current.on('afterInit', () => {
                firstElWithBadge = lightRoomRef.current.pswp.currSlide.data.element;
                hideBadge(firstElWithBadge);
            });

            // Gallery is starting to close
            lightRoomRef.current.on('close', () => {
                lastElWithBadge = lightRoomRef.current.pswp.currSlide.data.element;
                if (lastElWithBadge !== firstElWithBadge) {
                    showBadge(firstElWithBadge);
                    hideBadge(lastElWithBadge);
                }
            });

            // Gallery is closed
            lightRoomRef.current.on('destroy', () => {
                showBadge(lastElWithBadge);
            });

            lightRoomRef.current.init();
        }
        function hideBadge(el) {
            el.querySelector('.badge').classList.add('badge--hidden');
        }
        function showBadge(el) {
            el.querySelector('.badge').classList.remove('badge--hidden');
        }
    };

    const initGallery = () => {
        const carouselThumbnails = document.getElementById('pdp__galleryThumb');
        const carousel = document.getElementById('pdp__gallery');
        const TotalNumberOfSlides = $('#thumbGallery').find('.swiper-wrapper').length;
        const slidesListChildren = document.getElementById('thumbGallery').children;
        const slidesList = Array.from(slidesListChildren).map((x) => x.id);

        Array.from(document.querySelectorAll('.pdpHide')).forEach(function (el) {
            el.classList.remove('pdpHide');
        });

        const swiperThumbnails = new Swiper(carouselThumbnails, {
            modules: [Navigation, Thumbs, A11y, Lazy],
            loop: false,
            slidesPerView: 'auto',
            //slidesPerGroup: 3,
            initialSlide: getDefaultIndexValue(),
            threshold: 2,
            preloadImages: false,
            lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: 5,
                loadOnTransitionStart: true,
                preloaderClass: 'gallery__preloader',
            },
            // slidesOffsetAfter: 25,
            // slidesOffsetBefore: 25,
            //navigation: false,
            watchSlidesProgress: true,
            watchOverflow: true,
            navigation: {
                nextEl: '.gallery-button-next',
                prevEl: '.gallery-button-prev',
            },
            // centeredSlides: true,
            // centeredSlidesBounds: true,
            breakpoints: {
                // when window width is >= 460
                460: {
                    //slidesPerGroup: 4,
                    spaceBetween: 0,
                },
                // when window width is >= 580
                580: {
                    //slidesPerGroup: 5,
                    spaceBetween: 0,
                },
                // when window width is >= 768
                768: {
                    //slidesPerGroup: 3,
                    spaceBetween: 0,
                },
                940: {
                    //slidesPerGroup: 4,
                    spaceBetween: 0,
                },
                // when window width is >= 1024
                1024: {
                    //slidesPerGroup: 5,
                    spaceBetween: 0,
                },
            },
        });
        const swiperGallery = new Swiper(carousel, {
            modules: [Navigation, Thumbs, A11y, Lazy],
            init: false,
            //zoom: window.innerWidth < 768 ? true : true,
            //zoom: false,
            freeMode: false,
            watchOverflow: true,
            lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: 2,
                loadOnTransitionStart: true,
                preloaderClass: 'gallery__preloader',
            },
            preloadImages: false,
            threshold: 2,
            loop: false,
            slidesPerView: 1,
            initialSlide: getDefaultIndexValue(),
            spaceBetween: 25,
            navigation: false,
            watchSlidesProgress: true,
            a11y: { enabled: true },
            thumbs: {
                swiper: swiperThumbnails,
            },
        });
        swiperRef.current = swiperGallery;
        swiperRefThumb.current = swiperThumbnails;
        setSwiperInstance(swiperGallery);

        //setup event handlers
        // swiperGallery.on('init', function () {
        //     console.log('init' + this.activeIndex + this.realIndex);
        // });
        // //swiper.init()
        // swiperGallery.on('afterInit', function () {
        //     console.log('afterInit' + this.activeIndex + this.realIndex);
        // });
        // swiperGallery.on('activeIndexChange', function () {
        //     console.log('activeIndexChange' + this.activeIndex + this.realIndex);
        // });
        // swiperGallery.on('realIndexChange', function () {
        //     console.log('realIndexChange' + this.activeIndex + this.realIndex);
        // });
        swiperGallery.on('slideChange', function () {
            const prevIndex = slideIndex;
            setSlideIndex(this.realIndex);
            setVideoData(getCurrentData());
            let currentSlideID = '';
            let currentSlideStyle = '';
            currentSlideID = this.slides[this.activeIndex].id;
            if (currentSlideID.includes('img-')) {
                currentSlideStyle = currentSlideID.replace('img-', '');
                //send event so Description area will update
                EventBus.dispatch('gotoStyle', { dimensionId: currentSlideStyle });
            }
        });
        swiperThumbnails.on('slideChange', function () {
            //swiperGallery.slideTo(swiperThumbnails.realIndex);
        });
        swiperGallery.on('afterInit', function () {
            const isAutoPlayEnabledFromCookie = getIsAutoPlayEnabledFromCookie();
            if (isAutoPlayEnabledFromCookie && window.innerWidth > 768) {
                const firstVideoIndex = findFirstVideoIndex();
                if (firstVideoIndex !== -1) {
                    //swiperRef.current.slideTo(1, 0);
                    swiperRef.current.slideTo(1, 1, false);
                    swiperRef.current.slidePrev(1, false);
                    swiperRefThumb.current.slideTo(1, 1, false);
                    swiperRefThumb.current.slidePrev(1, false);
                    //swiperRef.current.slidePrev(0, false);
                    setSlideIndex(firstVideoIndex);
                } else {
                    // go to slide with defaultEDP
                    //get style ID of default EDP
                    if (productData.Styles.length > 0) {
                        slideToCarouselByID(getDefaultEdpItem().StyleDimensionId);
                    } else {
                        swiperRef.current.slideTo(1, 1, false);
                        swiperRef.current.slidePrev(1, false);
                        swiperRefThumb.current.slideTo(1, 1, false);
                        swiperRefThumb.current.slidePrev(1, false);
                        setSlideIndex(0);
                    }
                }
            } else {
                if (productData.Styles.length > 0) {
                    slideToCarouselByID(getDefaultEdpItem().StyleDimensionId);
                } else {
                    swiperRef.current.slideTo(0 + productData.Videos.length, 0);
                    swiperRefThumb.current.slideTo(0 + productData.Videos.length, 0);
                    setSlideIndex(0 + productData.Videos.length);
                }
            }
        });
        swiperGallery.init();
        if (slidesListChildren.length <= 2) {
            swiperGallery.allowSlidePrev = false;
            swiperGallery.allowSlideNext = false;
            //swiperGallery.disable();
            const thumbGallery = document.getElementById('thumbGallery');
            if (thumbGallery) {
                thumbGallery.classList.add('hidden');
            }
        }
        //go to default slide (video or image depending on autoplay cookie value)

        //arrow event listener
        const thumbArrowPrev = document.querySelectorAll('.gallery-button-prev');
        thumbArrowPrev[0].addEventListener(
            'click',
            (e) => {
                e.stopPropagation();
                e.preventDefault();
                swiperRef.current.slidePrev();
                // swiperRefThumb.current.slidePrev();
            },
            true,
        );

        const thumbArrowNext = document.querySelectorAll('.gallery-button-next');
        thumbArrowNext[0].addEventListener(
            'click',
            (e) => {
                e.stopPropagation();
                e.preventDefault();
                swiperRef.current.slideNext();
                //swiperRefThumb.current.slideNext();
            },
            true,
        );

        //mount zoom feature
        mountZoom(swiperGallery);

        // //prevent click on anchor tags
        // const galleryLinks = document.querySelectorAll('a.gallery__image--aspect-ratio-wrap');
        // galleryLinks.forEach(function (link) {
        //     link.addEventListener(
        //         'click',
        //         (e) => {
        //             //e.stopPropagation();
        //             e.preventDefault();
        //             return false;
        //         },
        //         true,
        //     );
        // });
        swiperGallery.on('click', (e) => {
            if (!zoomRef.current) {
                zoomRef.current = true;
                document.getElementById('pdp__gallery').classList.add('zoom');
                swiperGallery.allowTouchMove = false;
            } else {
                zoomRef.current = false;
                document.getElementById('pdp__gallery').classList.remove('zoom');
                swiperGallery.allowTouchMove = true;
            }
        });

        return swiperGallery;
    };

    return (
        <>
            {/* {slideIndex} {swiperRef?.current?.realIndex} */}
            <PdpVideoItem
                VideoData={videoData}
                onAutoPlayChange={onAutoPlayChange}
                isAutoPlayEnabled={isAutoPlayEnabled}
            />
        </>
    );
};

export default PdpGallery;
